class ShowMoreElement extends HTMLElement {
  connectedCallback() {
    // Find the button inside this element and add click handler
    const button = this.querySelector('.show-more-btn');
    if (button) {
      button.addEventListener('click', this.handleShowMore.bind(this));
    }
  }

  handleShowMore() {
    // Find element with data-id="collection-description" attribute
    const targetElement = document.querySelector('[data-id="collection-description"]');
    
    if (targetElement) {
      // Smooth scroll to the target element
      targetElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    } else {
      console.warn('Element with data-id="collection-description" not found');
    }
  }
}

// Register the custom element
customElements.define('show-more-element', ShowMoreElement); 